'use client'
import { TextInput, TextArea, ColorButton, ReplyMessage, UserSearchInput, TextInputUpperCase } from "@/components/ui";
import { Contact, IdCard, Smile, Text } from "@/assets/icons";
import { registesClientSellerForm } from "@/app/api";
import { useRouter } from "next/navigation";
import { useActionState, useState } from "react";
import Form from "next/form";
import { SearchUser } from "@/types";

export function RegisterClientSeller({ sellerId }: { sellerId: string }) {
    const [state, formAction, pending] = useActionState(registesClientSellerForm, {
        values: { clientCode: '', clientUserName: '', clientName: '', observation: '', sellerId: sellerId },
        errors: {},
        message: '',
    })
    const [selectedClient, setSelectedClient] = useState<SearchUser | null>(null);

    const router = useRouter();
    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);
    }

    const handleClientSelect = (client: SearchUser) => {
        setSelectedClient(client);
    };

    return (
        <div className="border border-ochre_accent rounded-md p-6">

            <Form action={formAction} className="flex flex-col gap-3">

                <input type="hidden" name="sellerId" defaultValue={sellerId} required />

                {/* Search Input */}

                <div className="flex gap-2 items-center">
                    <IdCard className="size-4" />
                    <div className="flex gap-1 items-baseline">
                        <label htmlFor="clientCode">Buscar Cliente</label>
                        <p className="text-xs">Selecione um cliente abaixo para preencher os campos automaticamente</p>
                    </div>
                </div>
                <UserSearchInput onSelectUser={handleClientSelect} userType={"client"} />

                {/* code of client */}

                <div className="flex gap-2 items-center">
                    <IdCard className="size-4" />
                    <label htmlFor="clientCode">Código do Cliente</label>
                </div>
                <TextInput name="clientCode" id="clientCode"
                    minLength={4} maxLength={4} required
                    defaultValue={selectedClient?.code || state?.values?.clientCode}
                    placeholder="Código" />
                {state?.errors?.clientCode && <p>{state.errors.clientCode}</p>}

                {/* username of client */}

                <div className="flex gap-2 items-center">
                    <Contact className="size-4" />
                    <label htmlFor="clientUserName">Empresa</label>
                </div>
                <TextInputUpperCase name="clientUserName" id="clientUserName"
                    required
                    value={selectedClient?.userName || state?.values?.clientUserName}
                    placeholder="Empresa" />
                {state?.errors?.clientUserName && <p>{state.errors.clientUserName}</p>}


                {/* name of client */}

                <div className="flex gap-2 items-center">
                    <Smile className="size-4" />
                    <label htmlFor="clientName">Nome</label>
                </div>
                <TextInput name="clientName" id="clientName"
                    defaultValue={selectedClient?.name || state?.values?.clientName}
                    placeholder="Nome" />
                {state?.errors?.clientName && <p>{state.errors.clientName}</p>}

                {/* observation of client */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="observation">Observação</label>
                </div>
                <TextArea name="observation" id="observation"
                    defaultValue={state?.values?.observation}
                    placeholder="Observação" />
                {state?.errors?.observation && <p>{state.errors.observation}</p>}

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending ? 'Cadastrando...' : 'Cadastrar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}